import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteFollowUpRequest = async (id: number): Promise<boolean> => {
  const response = await mutationExecute({
    variables: { id },
    mutation: graphql(`
      mutation DeleteFollowUpRequest($id: Float!) {
        deleteFollowUpRequest(id: $id)
      }
    `),
  });
  return response.data?.deleteFollowUpRequest ?? false;
};
